import React from "react";
import { ApiFetch } from "../../../../../../config/api";
import { useAuthContextState } from "../../../../../../context/auth/authContext/authContextState";
import { FetchInterface, Method } from "../../../../../../enums/enum";
import BarChart from "../../../../../barChart/barChart";
import PersonalTableDashboard from "../../../../../personalTableDashboard/personalTableDashboard";

const CareerInfomationGender = React.forwardRef(({ data, address }, ref) => {
  const [modalShow, setModalShow] = React.useState(false);
  const [tableDataForFilter, setTableDataForFilter] = React.useState({});
  const { token } = useAuthContextState();
  const [tableData, setTableData] = React.useState({
    header: "",
    data: [],
  });
  React.useImperativeHandle(ref, () => ({
    async getPersonalInfoAllCareerAndGender() {
      setModalShow(true);
      try {
        const res = await ApiFetch({
          [FetchInterface.PATH]: `auth/career-personal-table-info/careerAndGender/${address.provice}/${address.amphur}/${address.tambol}/${address.group}`,
          [FetchInterface.METHOD]: Method.GET,
          [FetchInterface.TOKEN]: token.accessToken,
          [FetchInterface.PARAMS]: null,
        });
        if (res.status === 200) {
          setTableDataForFilter(res.data);
          setTableData({
            header: { datasetTitle: "ชายและหญิง", title: "ทุกอาชีพ" },
            data: res.data,
          });
        }
        // setLoading(false)
      } catch (error) {
        // setLoading(false)
        console.log(error);
      }
    },
  }));
  return (
    <>
      <div style={{ height: "42vh" }}>
        <BarChart
          data={data}
          setTableDataForFilter={setTableDataForFilter}
          address={address}
          section={"careerAndGender"}
          pathname={"career-personal-table-info"}
          setModalShow={setModalShow}
          setTableData={setTableData}
        />
      </div>
      <PersonalTableDashboard
        title={`ข้อมูลรายละเอียด เพศ ${tableData.header.datasetTitle} อาชีพ ${tableData.header.title} ใน ${address.addressName} จำนวน ${tableData?.data?.data?.length} คน`}
        tableData={tableData}
        modalShow={modalShow}
        setModalShow={setModalShow}
        setTableData={setTableData}
        tableDataForFilter={tableDataForFilter}
      />
    </>
  );
});
export default CareerInfomationGender;
